export default __webpack_public_path__ + "static/media/bag.e29bbc59.svg";